import { render, staticRenderFns } from "./CompanyEvaluate.vue?vue&type=template&id=2a8e3118&"
import script from "./CompanyEvaluate.vue?vue&type=script&lang=js&"
export * from "./CompanyEvaluate.vue?vue&type=script&lang=js&"
import style0 from "./CompanyEvaluate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "packages/cb-components-company-evaluate/src/components/companyEvaluate/CompanyEvaluate.vue"
export default component.exports